import React from "react";
import "./EducationTwoWorkFlow.scss";

const EducationTwoWorkFlow = () => {
  const [activeCard, setActiveCard] = React.useState(null);

  const steps = [
    {
      id: 1,
      title: "Start Your Search",
      description: "Begin by exploring our wide range of courses and programs",
      img: "https://img.freepik.com/free-vector/hands-holding-tablet-with-forefinger-clicking-start-button-new-application-launch-flat-illustration_74855-20595.jpg",
      icon: "🔍",
    },
    {
      id: 2,
      title: "Review Options",
      description:
        "Compare courses, read reviews, and check curriculum details",
      img: "https://img.freepik.com/free-vector/client-review-web-screen-successful-4-4-star-business-opinion_1150-37483.jpg",
      icon: "📋",
    },
    {
      id: 3,
      title: "Schedule",
      description: "Choose your preferred time and enroll in the course",
      img: "https://img.freepik.com/free-vector/schedule-concept-illustration_114360-1531.jpg",
      icon: "📅",
    },
    {
      id: 4,
      title: "Start Learning",
      description: "Begin your educational journey with expert guidance",
      img: "https://img.freepik.com/free-vector/learning-concept-landing-page_23-2147777592.jpg",
      icon: "🎓",
    },
  ];

  return (
    <section className="workflow-section">
      <div className="container">
        <div className="section-header">
          <h3 className="sect_title">
            Get Your{" "}
            <span className="relative">
              Path
              <span className="title-shape">
                <svg
                  width="150"
                  height="65"
                  viewBox="0 0 168 65"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="highligt_text"
                >
                  <path
                    d="M73.3761 8.49147C78.4841 6.01353 82.5722 4.25154 88.8933 3.3035C94.2064 2.50664 99.6305 2.0701 104.981 1.94026C120.426 1.56549 135.132 4.90121 146.506 9.70405C158.628 14.8228 166.725 22.5638 166.074 31.6501C165.291 42.5779 151.346 51.7039 133.508 56.8189C110.253 63.4874 81.7065 63.8025 58.5605 60.8285C37.5033 58.123 11.6304 51.7165 3.58132 40.0216C-3.43085 29.8337 12.0728 18.1578 27.544 11.645C40.3656 6.24763 55.7082 2.98328 70.8043 4.08403C81.9391 4.89596 93.2164 6.87822 102.462 9.99561C112.874 13.5066 120.141 18.5932 127.862 23.6332"
                    stroke="var(--click-color)"
                    strokeWidth="3"
                    strokeLinecap="round"
                  ></path>
                </svg>
              </span>
            </span>{" "}
            in simple four steps.
          </h3>
          <div className="underline"></div>
        </div>

        <div className="workflow-steps">
          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`step-card ${activeCard === step.id ? "active" : ""}`}
              onClick={() => setActiveCard(step.id)}
            >
              <div className="step-number">{index + 1}</div>
              <div className="step-icon" aria-hidden="true">
                {step.icon}
              </div>
              <div className="step-image">
                <img src={step.img} alt={step.title} loading="lazy" />
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationTwoWorkFlow;
